const s3FileType = 5;
function formatNumber(num) {
  const numb = Number(num);
  if (Number.isNaN(numb)) {
    return 0;
  }
  return numb;
}
function autoAddZero(num) {
  const digit = formatNumber(num);
  if (digit >= 0 && digit < 10) {
    return `0${digit}`;
  }
  return digit;
}
export function GET_TOKEN_JSON(token) {
  const JWT = require("jsonwebtoken");
  const json = JWT.decode(token);
  return json;
}
export function CREAGEIMGKEY(Id) {
  const userId = Id || window.sessionStore.getItem("username");
  const d = new Date();
  const year = d.getFullYear();
  const month = autoAddZero(d.getMonth() + 1);
  const day = autoAddZero(d.getDate());
  const h = autoAddZero(d.getHours());
  const m = autoAddZero(d.getMinutes());
  const s = autoAddZero(d.getSeconds());
  let random = (Math.random() * 10000).toFixed(0);
  if (random.length === 3) {
    random += "0";
  }
  const imgNameKey = `${year}${month}${day}_${h}${m}${s}_${random}_${s3FileType}`;
  return `${userId}/${imgNameKey}`;
}
export function CHECK_WELCOME_KEY() {
  let key = "";
  const time = new Date();
  const hores = time.getHours();
  if (hores >= 6 && hores <= 12) {
    key = "goodMorning";
  } else if (hores > 12 && hores <= 18) {
    key = "goodAfternoon";
  } else if (hores > 18 || hores < 6) {
    key = "goodEvening";
  }
  return key;
}
// base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
export function dataURLtoFile(dataurl, fileName) {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  const n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n - 1 > 0) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
}
const ratingConfig = {
  excellent: {
    min: 13,
    max: 100,
  },
  good: {
    min: 7,
    max: 12,
  },
  fail: {
    min: 0,
    max: 6,
  },
};

export function ENCODE(data) {
  const str = data.reduce((a, b) => {
    return a + String.fromCharCode(b);
  }, "");
  return btoa(str).replace(/.{76}(?=.)/g, "$&\n");
}

export function DIFF_ARRS(arrA, arrB, key) {
  if (key) {
    return arrA.filter((a) => !arrB.some((b) => b[key] === a[key]));
  }
  return arrA.filter((a) => !arrB.some((b) => b === a));
}

export function FORMATDATE(dateStr, state) {
  if (
    !dateStr ||
    new Date(dateStr).getTime() < new Date("1970-01-01").getTime()
  ) {
    return "";
  }
  const d = new Date(dateStr);

  if (!Number.isNaN(d)) {
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    const h = d.getHours();
    const m = d.getMinutes();
    const s = d.getSeconds();
    if (state) {
      return `${year.toString()}-${autoAddZero(month + 1)}-${autoAddZero(
        day
      )} ${autoAddZero(h)}:${autoAddZero(m)}:${autoAddZero(s)}`;
    }
    return `${year.toString()}-${autoAddZero(month + 1)}-${autoAddZero(day)}`;
  }
  return "";
}
// 压缩图片
export function compressImage(file) {
  let files;
  const fileSize = parseFloat(window.parseInt(file.size) / 1024 / 1024).toFixed(
    2
  );
  const fileName = file.name;
  const read = new FileReader();
  read.readAsDataURL(file);
  return new Promise((resolve, reject) => {
    read.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        // 默认按比例压缩
        const w = this.width;
        const h = this.height;
        // 生成canvas
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        let base64;
        // 创建属性节点
        canvas.setAttribute("width", w);
        canvas.setAttribute("height", h);
        ctx.drawImage(this, 0, 0, w, h);
        // base64 = canvas.toDataURL('image/jpeg', 0.1)
        if (fileSize < 1) {
          // 如果图片小于一兆 那么不执行压缩操作
          base64 = canvas.toDataURL("image/jpeg", 1);
        } else if (fileSize > 1 && fileSize < 2) {
          // 如果图片大于1Mi小于2m 那么压缩0.5
          base64 = canvas.toDataURL("image/jpeg", 0.5);
        } else {
          // 如果图片超过2m 那么压缩0.2
          base64 = canvas.toDataURL("image/jpeg", 0.2);
        }
        // 回调函数返回file的值（将base64编码转成file）
        files = dataURLtoFile(base64, fileName); // 如果后台接收类型为base64的话这一步可以省略

        resolve(files);
      };
    };
    read.onerror = () => {
      reject();
    };
  });
}

export function FORMAT_APOLLO_CONFIG(obj) {
  if (!obj || JSON.stringify(obj) === "{}") {
    return {};
  }
  const tempObj = {};
  Object.entries(obj).forEach(([k, item]) => {
    const tempArr = k.split(":");
    const subKey = tempArr[0];
    if (!tempObj[subKey]) {
      tempObj[subKey] = {};
    }
    tempObj[subKey][tempArr[1]] = item;
  });
  return tempObj;
}
// 计算评分等级
export function checkRating(total) {
  const ratineNum = total;
  let str = "";
  Object.entries(ratingConfig).forEach(([k, item]) => {
    if (ratineNum >= item.min && ratineNum <= item.max) {
      str = k.substring(0, 1).toUpperCase() + k.substring(1);
    }
  });
  return str;
}
// 处理AWS 用户信息
export function checkUserAttributes(attr) {
  const obj = {};
  for (let i = 0; i < attr.length; i += 1) {
    const item = attr[i];
    const key = item.name;
    const val = item.value;
    obj[key] = val;
  }
  return obj;
}

const SYS_FUNCTIONS = {
  ENCODE: (data) => {
    const str = data.reduce((a, b) => {
      return a + String.fromCharCode(b);
    }, "");
    return btoa(str).replace(/.{76}(?=.)/g, "$&\n");
  },
  DIFF_ARRS: (arrA, arrB, key) => {
    if (key) {
      return arrA.filter((a) => !arrB.some((b) => b[key] === a[key]));
    }
    return arrA.filter((a) => !arrB.some((b) => b === a));
  },
  FORMATDATE: (dateStr, state) => {
    if (
      !dateStr ||
      new Date(dateStr).getTime() < new Date("1970-01-01").getTime()
    ) {
      return "";
    }
    const d = new Date(dateStr);

    if (!Number.isNaN(d)) {
      const year = d.getFullYear();
      const month = d.getMonth();
      const day = d.getDate();
      const h = d.getHours();
      const m = d.getMinutes();
      const s = d.getSeconds();
      if (state) {
        return `${year.toString()}-${autoAddZero(month + 1)}-${autoAddZero(
          day
        )} ${autoAddZero(h)}:${autoAddZero(m)}:${autoAddZero(s)}`;
      }
      return `${year.toString()}-${autoAddZero(month + 1)}-${autoAddZero(day)}`;
    }
    return "";
  },

  CREAGEIMGKEY: (Id) => {
    const userId = Id || window.sessionStore.getItem("username");
    const d = new Date();
    const year = d.getFullYear();
    const month = autoAddZero(d.getMonth() + 1);
    const day = autoAddZero(d.getDate());
    const h = autoAddZero(d.getHours());
    const m = autoAddZero(d.getMinutes());
    const s = autoAddZero(d.getSeconds());
    let random = (Math.random() * 10000).toFixed(0);
    if (random.length === 3) {
      random += "0";
    }
    const imgNameKey = `${year}${month}${day}_${h}${m}${s}_${random}_${s3FileType}`;
    return `${userId}/${imgNameKey}`;
  },
  CHECK_WELCOME_KEY: () => {
    let key = "";
    const time = new Date();
    const hores = time.getHours();
    if (hores >= 6 && hores <= 12) {
      key = "goodMorning";
    } else if (hores > 12 && hores <= 18) {
      key = "goodAfternoon";
    } else if (hores > 18 || hores < 6) {
      key = "goodEvening";
    }
    return key;
  },
  // 压缩图片
  compressImage: (file) => {
    let files;
    const fileSize = parseFloat(
      window.parseInt(file.size) / 1024 / 1024
    ).toFixed(2);
    const fileName = file.name;
    const read = new FileReader();
    read.readAsDataURL(file);
    return new Promise((resolve, reject) => {
      read.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          // 默认按比例压缩
          const w = this.width;
          const h = this.height;
          // 生成canvas
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          let base64;
          // 创建属性节点
          canvas.setAttribute("width", w);
          canvas.setAttribute("height", h);
          ctx.drawImage(this, 0, 0, w, h);
          // base64 = canvas.toDataURL('image/jpeg', 0.1)
          if (fileSize < 1) {
            // 如果图片小于一兆 那么不执行压缩操作
            base64 = canvas.toDataURL("image/jpeg", 1);
          } else if (fileSize > 1 && fileSize < 2) {
            // 如果图片大于1Mi小于2m 那么压缩0.5
            base64 = canvas.toDataURL("image/jpeg", 0.5);
          } else {
            // 如果图片超过2m 那么压缩0.2
            base64 = canvas.toDataURL("image/jpeg", 0.2);
          }
          // 回调函数返回file的值（将base64编码转成file）
          files = dataURLtoFile(base64, fileName); // 如果后台接收类型为base64的话这一步可以省略

          resolve(files);
        };
      };
      read.onerror = () => {
        reject();
      };
    });
  },
  FORMAT_APOLLO_CONFIG: (obj) => {
    if (!obj || JSON.stringify(obj) === "{}") {
      return {};
    }
    const tempObj = {};
    Object.entries(obj).forEach(([k, item]) => {
      const tempArr = k.split(":");
      const subKey = tempArr[0];
      if (!tempObj[subKey]) {
        tempObj[subKey] = {};
      }
      tempObj[subKey][tempArr[1]] = item;
    });
    return tempObj;
  },
  // 计算评分等级
  checkRating: (total) => {
    const ratineNum = total;
    let str = "";
    Object.entries(ratingConfig).forEach(([k, item]) => {
      if (ratineNum >= item.min && ratineNum <= item.max) {
        str = k.substring(0, 1).toUpperCase() + k.substring(1);
      }
    });
    return str;
  },
  // 处理AWS 用户信息
  checkUserAttributes: (attr) => {
    const obj = {};
    for (let i = 0; i < attr.length; i += 1) {
      const item = attr[i];
      const key = item.name;
      const val = item.value;
      obj[key] = val;
    }
    return obj;
  },
  GET_TOKEN_JSON(token) {
    const JWT = require("jsonwebtoken");
    const json = JWT.decode(token);
    return json;
  },
};
export default SYS_FUNCTIONS;
